import { useState, useEffect } from "react";
import { backend } from "../api";
import { loadConnectAndInitialize } from "@stripe/connect-js";

export const useStripeConnect = (connectedAccountId) => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState();

  useEffect(() => {
    if (connectedAccountId) {
      const fetchClientSecret = async () => {
        try {
          const response = await backend.post(
            "/stripe-connect/account_session",
            {
              account: connectedAccountId,
            }
          );

          if (response.status !== 200) {
            throw new Error(
              response.data.error || "Failed to fetch client secret"
            );
          }

          const { client_secret: clientSecret } = response.data;
          return clientSecret;
        } catch (error) {
          console.error(
            "An error occurred while fetching client secret:",
            error
          );
          throw error;
        }
      };

      setStripeConnectInstance(
        loadConnectAndInitialize({
          publishableKey:
            "pk_test_51Mm4i5BbiNWHJzfiKwdLrGwuhvo9zqQDTsxtKTePi6iliH6VWYL4TEVFB3N3EnnmnGyp3dlldupuIiVsuC8C8F4K00snGFrutv",
          fetchClientSecret,
          appearance: {
            overlays: "dialog",
            variables: {
              colorPrimary: "#635BFF",
            },
          },
        })
      );
    }
  }, [connectedAccountId]);

  return stripeConnectInstance;
};

export default useStripeConnect;
